import { Component } from '@angular/core';

@Component({
  selector: 'zc-modal-footer',
  templateUrl: './modal-footer.component.html',
})
export class ModalFooterComponent {}
